import { render, staticRenderFns } from "./Glucose.vue?vue&type=template&id=dc4e3714&"
import script from "./Glucose.vue?vue&type=script&lang=js&"
export * from "./Glucose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports